import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { SubscriptionService, TrialStatusModel } from "./subscription.service";
import { getTrialState, setTrialState } from "src/app/shared/utils/trial.util";
import { updateLoggedInUser } from "src/app/shared/utils/plan.util";

@Injectable({ providedIn: "root" })
export class TrialStateService {
  private readonly stateSubject = new BehaviorSubject<TrialStatusModel | null>(getTrialState());
  readonly state$: Observable<TrialStatusModel | null> = this.stateSubject.asObservable();

  constructor(private subscriptionService: SubscriptionService) {}

  get snapshot(): TrialStatusModel | null {
    return this.stateSubject.value;
  }

  /** Re-reads trial status from the API. Keeps the cached value when the request fails. */
  refresh(): Observable<TrialStatusModel | null> {
    if (!localStorage.getItem("LoggedInUser")) {
      this.clear();
      return of(null);
    }

    return this.subscriptionService.getTrialStatus().pipe(
      tap((state) => this.set(state)),
      catchError(() => of(this.stateSubject.value))
    );
  }

  cancelTrial(): Observable<boolean> {
    return this.subscriptionService.cancelTrial().pipe(
      tap(() => {
        updateLoggedInUser({ effectivePlanId: "standard", EffectivePlanId: "standard" });
        const current = this.stateSubject.value;
        this.set(current ? { ...current, active: false, eligible: false } : null);
      }),
      map((res) => res?.success === true)
    );
  }

  set(state: TrialStatusModel | null): void {
    setTrialState(state);
    this.stateSubject.next(state);
  }

  clear(): void {
    this.set(null);
  }
}
